import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@common/i18n';

const ProductHighLights = ({ overview, highlights }) => {
  const t = useTranslation();
  const showLimit = 5;
  const [showAll, setShowAll] = React.useState(false);
  const [attributes, setAttributes] = React.useState(highlights);
  const shortDescription = overview?.find((item) => item?.attributeCode === 'short_description');
  React.useEffect(() => {
    if (!showAll && highlights?.length > showLimit) {
      setAttributes(highlights?.slice(0, showLimit));
    } else {
      setAttributes(highlights);
    }
  }, [showAll, highlights]);
  if (highlights?.length > 0) {
    return (
      <div className="highlightBox">
        <div className="titleBar">{t('ProductDetail.highlights')}</div>
        <div className="contentArea">
          <div className={`listingItems ${highlights?.length <= showLimit ? 'noSpacing border-0' : ''}`}>
            {attributes?.length > 0
              ? attributes?.map((item) => {
                  return (
                    <div className="listRow" key={item?.attributeCode}>
                      <div className="listLabel">{item?.attributeLabel}</div>
                      <div className="listValue">{item?.label}</div>
                    </div>
                  );
                })
              : shortDescription && <div dangerouslySetInnerHTML={{ __html: shortDescription?.label }} />}
            {/* <div className="listRow">
            <div className="listLabel">Protein Type</div>
            <div className="listValue">Whey Protein</div>
          </div> */}
          </div>
          {highlights?.length > showLimit && (
            <div
              className="btnShowMore"
              onClick={() => {
                setShowAll(!showAll);
              }}
            >
              {showAll ? t('ProductDetail.showLess') : t('ProductDetail.showMore')}
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return '';
  }
};

ProductHighLights.propTypes = {
  overview: PropTypes.any,
  highlights: PropTypes.any,
};

export default ProductHighLights;
